// libs
import React, { memo, useRef } from 'react';
import get from 'lodash/get';

// components
import WidgetTitle from 'shared/components/AdPlatformWidgets/components/WidgetTitle';

// styles
import { Wrapper } from './styles';
import { BREAKPOINTS } from 'shared/styles/base';

// context
import { useResponsiveContext } from 'components/ResponsiveLoader/ResponsiveContext';

// defs
import { ILandingPageWidget } from 'shared/components/AdPlatformWidgets/types';

// hooks
import { useTrackingObserver } from 'shared/components/AdPlatformWidgets/ImpressionTracking/trackingHooks';

// helpers
import './deeplink';

interface IStoryProps {
  widget: ILandingPageWidget;
}

function Story({ widget }: IStoryProps) {
  const { deviceWidth } = useResponsiveContext();
  const isMobile = deviceWidth < BREAKPOINTS.DESKTOP;

  const title = get(widget, 'widget_data.parameters.title', '');
  const titleAlign = get(widget, 'widget_data.parameters.title_align_desktop', 'left');
  let detail = get(widget, 'widget_data.parameters.detail', '');

  const widgetRef = useRef<HTMLElement>(null);
  const trackingData = get(widget, 'widget_data.trackingData');
  useTrackingObserver({ widgetRef, trackingData });

  if (detail === '') {
    return null;
  }

  if (isMobile) {
    detail = detail.replace(/target="_blank"/g, 'target="_self"');
  }

  return (
    <Wrapper ref={widgetRef}>
      {title && <WidgetTitle title={title} alignment={titleAlign} />}

      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: detail,
        }}
      />
    </Wrapper>
  );
}

export default memo(Story);
